import type { QueryClient } from '@tanstack/react-query';

/**
 * Cuando el navegador restaura la página desde su caché de retroceso (bfcache),
 * la vista vuelve tal como se dejó: datos viejos y, a veces, un formulario con
 * lo que ya se envió. Al restaurarla se refrescan las consultas y la sesión, así
 * lo que se muestra vuelve a salir del servidor y no de la copia en memoria.
 *
 * Devuelve la función que quita el listener.
 */
export function escucharRestauracionDesdeCache(cliente: QueryClient): () => void {
  const alMostrar = (evento: PageTransitionEvent): void => {
    if (evento.persisted) void cliente.invalidateQueries();
  };
  window.addEventListener('pageshow', alMostrar);
  return () => window.removeEventListener('pageshow', alMostrar);
}
